<script setup>
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import {useMutation, useQueryClient} from "@tanstack/vue-query";
import axios from "axios";
import {errorToast, successToast} from "@/composables/useToasts";
import Swal from "sweetalert2";
import moment from "moment";

const props = defineProps({
  approvalId: {
    type: Number,
    required: true,
  },
  autoApproveAt: {
    type: String,
    required: true,
  }
})

const confirmExtension = () => {
  const extendToDate = moment(props.autoApproveAt).add(1, 'week').format('Do MMM YYYY')
  Swal.fire({
    icon: 'warning',
    title: 'Confirm approval delay',
    html: `Please confirm that you want to push the automatic approval date back to the ${extendToDate}.
           <br><br>
           If you’re happy to delay, click Confirm.`,
    showCancelButton: true,
    confirmButtonText: 'Confirm',
    confirmButtonColor: '#2F52E0',
    preConfirm() {
      mutate()
    }
  })
}

const queryClient = useQueryClient();
const {mutate, isPending} = useMutation({
  mutationFn: async () => {
    await queryClient.cancelQueries({ queryKey: ['approvals'] })
    await axios.post(`/ajax/v2/approval-center/${props.approvalId}/extend-auto-approve/`)
  },
  onSuccess: () => {
    successToast('Auto approval date extended by 1 week')
  },
  onError: (error) => {
    errorToast(error.response.data.message || 'Something went wrong extending the auto approve date')
  },
  onSettled: () => {
    queryClient.invalidateQueries({
      queryKey: ['approvals']
    })
  }
})
</script>

<template>
  <DefaultButton
    size="small"
    variant="primary-inverted"
    :loading="isPending"
    :disabled="isPending"
    @click="confirmExtension"
  >
    <svg-vue
      v-if="!isPending"
      class="tw-h-6 tw-mr-2"
      icon="icons/add-time-clock"
    />
    Extend (1 Week)
  </DefaultButton>
</template>
